import styled, { css } from 'styled-components'
import media from 'styled-media-query'

export const DeleteStyled = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  img {
    /* width: 100px; */
  }
  .content {
    display: flex;
    flex-direction: column;
    margin-top: 0 !important;
  }
  .actions {
    display: flex;
    justify-content: space-between;
    width: 100%;
    button {
      max-width: 45%;
    }
  }
`
export const Wrapper = styled.div`
  ${({ theme }) => css`
    table {
      width: 100%;
      border: 1px solid ${theme.colors.xxlightGray};

      tr {
        :last-child {
          td {
            border-bottom: 0;
          }
        }
      }

      th {
        text-align: start;
        color: ${theme.colors.blue};
        font-family: ${theme.font.montserrat};
        font-weight: ${theme.font.normal};
        font-size: ${theme.font.sizes.normal};
        padding: 0.6rem;
        border-bottom: 1px solid ${theme.colors.xxlightGray};
      }
      .clickable-div {
        width: 90%;
        justify-content: start;
        cursor: pointer;
      }
      .main-row {
        display: flex;
        align-items: center;

        color: ${theme.colors.white};
        background: ${theme.colors.blue};
        font-family: ${theme.font.montserrat};
        font-weight: ${theme.font.xbold};
        font-size: ${theme.font.sizes.normal};
        border-radius: 4px;
        padding: 0.6rem;
        margin-bottom: 2px;

        > .buttons-wrapper {
          display: flex;
          align-items: center;
          justify-content: center;

          .edit-button,
          .trash-button {
            background: ${theme.colors.white};
            box-shadow: 0px 4px 2px rgba(0, 0, 0, 0.15);
            border-radius: 8px;
            margin-right: 10px;
            cursor: pointer;
          }

          .edit-button {
            border: 1px solid ${theme.colors.primary};
          }

          .trash-button {
            border: 1px solid ${theme.colors.red};
          }

          .plus-button {
            display: flex;
            align-items: center;
            background: none;
            color: ${theme.colors.white};
            font-size: ${theme.font.sizes.medium};
            cursor: pointer;
          }
        }
      }

      .collapse {
        display: none;

        .collapse-content {
          border: 1px solid ${theme.colors.xxlightGray};
          display: flex;
          padding: 0;
          flex-direction: column;
          width: 100%;
          margin-top: -5px;
          margin-left: 36px;

          h4 {
            background: ${theme.colors.xxxlightGray};
            border-bottom: 1px solid ${theme.colors.xxlightGray};
            color: ${theme.colors.darkGray};
            font-family: ${theme.font.montserrat};
            font-weight: ${theme.font.normal};
            font-size: ${theme.font.sizes.normal};
            padding: 12px 8px;
          }

          a,
          .reports-link {
            display: flex;
            align-items: center;
            justify-content: space-between;
            border-bottom: 1px solid ${theme.colors.xxlightGray};
            padding: 10px 8px;
            background: ${theme.colors.white};
            color: ${theme.colors.darkGray};
            font-family: ${theme.font.montserrat};
            font-weight: ${theme.font.normal};
            font-size: ${theme.font.sizes.normal};
            text-decoration: none;
            transition: filter ${theme.transition.default};
            cursor: pointer;

            &:hover {
              filter: brightness(0.95);
            }

            &:last-child {
              border-bottom: none;
            }

            .tags-collapse {
              display: flex;
              width: 148px;
              align-items: center;
              justify-content: space-between;

              p {
                background: ${theme.colors.lightGreen};
                margin-right: 10px;
                color: ${theme.colors.primary};
                padding: 2px 18px;
                margin: 0;
                border-radius: ${theme.border.radius};
              }
            }

            svg {
              transform: rotate(180deg);
              margin-right: 12px;

              path {
                fill: ${theme.colors.secondary};
              }
            }
          }
        }

        &.active {
          display: flex;
        }

        ${media.lessThan('small')`
          .collapse-content {
            margin-left: 0;

            h4 {
              font-size: ${theme.font.sizes.xxxsmall};
              padding: 8px 4px;
            }

            a,
            .reports-link {
              padding: 6px;
              font-size: ${theme.font.sizes.xxxsmall};

              .tags-collapse {
                width: 100px;

                p {
                  padding: 2px;
                  margin: 0;
                  border-radius: ${theme.border.radius};
                  font-size: 0.7rem;
                }
              }
            }
          }
        `}
      }
    }
  `}
`
